import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
export class AttributeViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getAttributeTypeOptions = () => {
    var attributeTypeArray = Storage.parseAttributeTypeOptions();
    this.updateState("attributeTypeOptions", attributeTypeArray);
  };

  getAttributes = async () => {
    //CRITICAL - ERROR MESSAGE
    var attributeResponse = await this.getAttributeListByCodeTag();
    if (
      Format.isNotNull(attributeResponse.errorCode) &&
      attributeResponse.errorCode === 0
    ) {
      if (Format.isNotNull(attributeResponse.attributeList)) {
        this.updateState("attributeList", attributeResponse.attributeList);
        this.logger.info(attributeResponse.attributeList);
      }
    } else {
      this.showError("Attribute", CrudlStatus.LIST);
    }
  };
  getAttributesReturned = async () => {
    //CRITICAL - ERROR MESSAGE
    var attributeResponse = await this.getAttributeListByCodeTag();
    if (
      Format.isNotNull(attributeResponse.errorCode) &&
      attributeResponse.errorCode === 0
    ) {
      if (Format.isNotNull(attributeResponse.attributeList)) {
        this.logger.info(attributeResponse.attributeList);
        return attributeResponse.attributeList;
      }
    } else {
      this.showError("Attribute", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    attributes,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedAttributeList = [];
    if (type === CrudlStatus.CREATE) {
      updatedAttributeList = this.reloadAfterCreate(
        attributes,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedAttributeList = this.reloadAfterUpdate(
        attributes,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedAttributeList = this.reloadAfterDelete(
        attributes,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("attributeList", updatedAttributeList);
  };

  reloadAfterCreate = (attributeList, apiResponse, externalStateValues) => {
    if (attributeList === undefined || attributeList === null) {
      attributeList = [];
    }
    var attributeBean = externalStateValues.attributeBean;
    attributeBean.id = apiResponse.id;
    attributeBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    attributeList.push(attributeBean);

    return attributeList;
  };

  reloadAfterUpdate = (attributeList, apiResponse, externalStateValues) => {
    var i = 0;
    attributeList.forEach(e => {
      if (apiResponse.id === e.id) {
        attributeList[i] = externalStateValues.attributeBean;
        attributeList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return attributeList;
  };

  reloadAfterDelete = (attributeList, apiResponse, externalStateValues) => {
    var i = 0;
    attributeList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        attributeList.splice(i, 1);
      }
      i++;
    });

    return attributeList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let attributeRequest = CloudService.AttributeRequest.constructFromObject(
      stateVariables.attributeBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createAttribute(attributeRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateAttribute(attributeRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteAttribute(attributeRequest);
    }
  };

  createAttribute = async (attributeRequest, stateVariables) => {
    attributeRequest.codeTag = this.codeTag;
    attributeRequest.userId = this.userId;
    attributeRequest.usageType = "PART";

    let attributeResponse = await ApiService.attributeCreate(attributeRequest);
    if (attributeResponse.errorCode === 0) {
      this.showSuccess("Attribute", CrudlStatus.CREATE);
    } else {
      this.showError("Attribute", CrudlStatus.CREATE);
    }

    return attributeResponse;
  };

  deleteAttribute = async attributeRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = attributeRequest.id;
    request.lastUpdatedDateTime = attributeRequest.lastUpdatedDateTime;

    let attributeResponse = await ApiService.attributeDelete(request);
    if (attributeResponse.errorCode === 0) {
      this.showSuccess("Attribute", CrudlStatus.DELETE);
    } else {
      this.showError("Attribute", CrudlStatus.DELETE);
    }

    return attributeResponse;
  };

  updateAttribute = async (attributeRequest, stateVariables) => {
    attributeRequest.codeTag = this.codeTag;
    attributeRequest.userId = this.userId;
    attributeRequest.usageType = "PART";

    let attributeResponse = await ApiService.attributeUpdate(attributeRequest);
    if (attributeResponse.errorCode === 0) {
      this.showSuccess("Attribute", CrudlStatus.UPDATE);
    } else {
      this.showError("Attribute", CrudlStatus.UPDATE);
    }

    return attributeResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Attributes/AttributeViewModel.js